"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductDetailUrl = void 0;
const getProductDetailUrl = ({
  pdpUrl,
  productCode
}) => pdpUrl ?? `/products/product?code=${productCode}`;
exports.getProductDetailUrl = getProductDetailUrl;
